import React from 'react'
import styled from 'styled-components'
import { H1 } from './core'
//import SkillCardBG from './SkillCardBackground'
import { theme, breakpoints } from '../ui-config'
import UX_1x from '../images/UX-colored.png'
import UX_2x from '../images/UX-colored@2x.png'
import network_1x from '../images/network-colored.png'
import network_2x from '../images/network-colored@2x.png'
import dev_1x from '../images/dev-colored.png'
import dev_2x from '../images/dev-colored@2x.png'

const CARD_GUTTER = 10;
const SMALL_SKILL_CARD_W = 98

const Container = styled.section`
    display: flex;
    flex-wrap: wrap;
    height: 85vh;
    margin: 0 auto;
    max-width: ${breakpoints.large}px;

    @media (max-width: ${breakpoints.large}px) {
        &::after {
            content: '';
            width: 100%;
        }
    }

    @media (max-width: ${breakpoints.small}px) {
        height: unset;
    }
`

const IntroTextContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 100px;

    @media (max-width: ${breakpoints.large}px) {
        margin-top: 12vh;
        margin-bottom: 4vh;
        max-width: 50%;
    }
    @media (max-width: ${breakpoints.medium}px) {
        margin-top: 18vh;
        text-align: center;
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
        max-width: 90%;

    }
`

const SkillCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: ${breakpoints.large}px) {
        order: 1;
        flex: 1;
        flex-direction: row;
        justify-content: start;
    }

    @media (max-width: ${breakpoints.medium}px) {
        justify-content: center;
    }
`

const SkillCardsInnerContainer = styled.div`
    display: flex;
`

const StyledSkillCard = styled.div`
    height: 227px;
    width: 140px;
    color: ${theme.coloredHeaders};
    position: relative;
    flex: 1;
    border: 2px solid ${theme.coloredHeaders};
    border-radius: 10px;

    @media (max-width: ${breakpoints.small}px) {
        & {
            margin-top: 20px;
            width: ${SMALL_SKILL_CARD_W}px;
        }
    }
`

const SkillCardContent = styled.div`
    top: 0;
    left: 0;
    display: flex;
    position: absolute;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px;
    font-size: 1.5rem;

    @media (max-width: ${breakpoints.small}px) {
        padding: 10px;
        font-size: 1.2rem;
    }
`

// "${props => props.icons['2x']}" 2x);
const SkillCardIcon = styled.div`
    background-image: url(${props => props.icons['1x']});
    height: 46px;
    background-repeat: no-repeat;
    background-position: center;
    width: auto;
    margin-bottom: 25px;
    margin-top: 15px;

    @media (max-width: ${breakpoints.small}px) {
        margin-top: 40px;
        margin-bottom: 20px;
    }
`

const SkillCardText = styled.div`
    flex: 1;
`

const SkillCard = (props) => {
    return (
        <StyledSkillCard style={props.style}>
            <SkillCardContent>
                <SkillCardIcon icons={props.icons} />
                <SkillCardText>{ props.text }</SkillCardText>
            </SkillCardContent>
        </StyledSkillCard>
    )
}
//<H3>Launching a new product is complex.<br />Let me help.</H3>
export default function Intro() {
    return (
        <Container>
            <IntroTextContainer>
                <H1>{'Digital Strategy,'}<br />{'Engineering \u0026'}<br />{'Experience Design'}</H1>
                <p>
                Tyler is a technology leader and digital strategist passionate about building
                innovative solutions that make an impact. With extensive experience leading
                teams building consumer, healthcare, and enterprise applications, he combines
                technical expertise with strategic vision to help organizations leverage
                technology to drive growth.
                </p>
            </IntroTextContainer>
            <SkillCardsContainer>
                <SkillCardsInnerContainer>
                    <SkillCard
                    text={'User Research  \u0026  Rapid Prototyping'}
                    icons={{ '1x': UX_1x, '2x': UX_2x }}
                    style={{ marginRight: `${CARD_GUTTER}px` }}/>
                    <SkillCard
                    icons={{ '1x': dev_1x, '2x': dev_2x }}
                    text={'Web Development \u0026 Systems Integration'}
                    />
                    <SkillCard
                    icons={{ '1x': network_1x, '2x': network_2x }}
                    text={'Data Science \u0026 Data Visualization'}
                    style={{ marginLeft: `${CARD_GUTTER}px` }}
                    />
                </SkillCardsInnerContainer>
            </SkillCardsContainer>
        </Container>
    )
}



// WEBPACK FOOTER //
// ./src/components/Intro.js